{
  "classes": [
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.BasicAllianceDescription",
      "typeName": "BasicAllianceDescription"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.DoubleEliminationSeriesDescription",
      "typeName": "DoubleEliminationSeriesDescription"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.PlayoffStructure",
      "typeName": "PlayoffStructure"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.RoundRobinAllianceDescription",
      "typeName": "RoundRobinAllianceDescription"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.SeriesAllianceDescription",
      "typeName": "SeriesAllianceDescription"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.SeriesDescription",
      "typeName": "SeriesDescription"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.inspection.InspectionUpdate",
      "typeName": "InspectionUpdate"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AdvancementConfig",
      "typeName": "AdvancementConfig"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.Award",
      "typeName": "Award"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AwardAssignment",
      "typeName": "AwardAssignment"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AwardPresentationContext",
      "typeName": "AwardPresentationContext"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.CenterStageScoreDetail",
      "typeName": "CenterStageScoreDetail"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.CommonAdvancement",
      "typeName": "CommonAdvancement"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.CommonEventParticipant",
      "typeName": "CommonEventParticipant"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.DecodeScoreDetail",
      "typeName": "DecodeScoreDetail"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.IntoTheDeepScoreDetail",
      "typeName": "IntoTheDeepScoreDetail"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.PowerPlayScoreDetail",
      "typeName": "PowerPlayScoreDetail"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.Release",
      "typeName": "Release"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.Sponsor",
      "typeName": "Sponsor"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference",
      "typeName": "TimeoutReference"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$AllianceLastMatchTimeout",
      "typeName": "AllianceLastMatchTimeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$G301Timeout",
      "typeName": "G301Timeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$LastOnFieldTimeout",
      "typeName": "LastOnFieldTimeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$RunningMatchTimeout",
      "typeName": "RunningMatchTimeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$ScheduledStartTimeout",
      "typeName": "ScheduledStartTimeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$T206MatchDependency",
      "typeName": "T206MatchDependency"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutReference$T206Timeout",
      "typeName": "T206Timeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommand",
      "typeName": "DisplayCommand"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$AbortMatch",
      "typeName": "AbortMatch"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$CancelMatch",
      "typeName": "CancelMatch"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$EndTimeout",
      "typeName": "EndTimeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$PitUpdate",
      "typeName": "PitUpdate"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$PlayVideo",
      "typeName": "PlayVideo"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$Randomize",
      "typeName": "Randomize"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$Redirect",
      "typeName": "Redirect"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ScoreUpdate",
      "typeName": "ScoreUpdate"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$SetConfig",
      "typeName": "SetConfig"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowAdvancement",
      "typeName": "ShowAdvancement"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowAward",
      "typeName": "ShowAward"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowBlank",
      "typeName": "ShowBlank"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowBracket",
      "typeName": "ShowBracket"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowInspectionStatus",
      "typeName": "ShowInspectionStatus"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowKey",
      "typeName": "ShowKey"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowMatch",
      "typeName": "ShowMatch"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowMessage",
      "typeName": "ShowMessage"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowOnlineResults",
      "typeName": "ShowOnlineResults"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowPreview",
      "typeName": "ShowPreview"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowRandom",
      "typeName": "ShowRandom"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowRankings",
      "typeName": "ShowRankings"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowResults",
      "typeName": "ShowResults"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowRoundResults",
      "typeName": "ShowRoundResults"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowSafetySecurity",
      "typeName": "ShowSafetySecurity"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowSelection",
      "typeName": "ShowSelection"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowSetup",
      "typeName": "ShowSetup"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowSlideshow",
      "typeName": "ShowSlideshow"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowSponsors",
      "typeName": "ShowSponsors"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowTimeout",
      "typeName": "ShowTimeout"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowVideo",
      "typeName": "ShowVideo"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowWifi",
      "typeName": "ShowWifi"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$StartMatch",
      "typeName": "StartMatch"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$TimeoutUpdate",
      "typeName": "TimeoutUpdate"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitBracketMessage",
      "typeName": "PitBracketMessage"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitOnlineURLMessage",
      "typeName": "PitOnlineURLMessage"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitPlayoffRank",
      "typeName": "PitPlayoffRank"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitRank",
      "typeName": "PitRank"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitRankingMessage",
      "typeName": "PitRankingMessage"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitResult$PlayoffPitResult",
      "typeName": "PlayoffPitResult"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitResult$QualsPitResult",
      "typeName": "QualsPitResult"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitResultMessage",
      "typeName": "PitResultMessage"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.utils.FLLConstants",
      "typeName": "FLLConstants"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.utils.FTCConstants",
      "typeName": "FTCConstants"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.utils.MatchTiming",
      "typeName": "MatchTiming"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.utils.ProgramConstants",
      "typeName": "ProgramConstants"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.AllianceDescription",
      "typeName": "AllianceDescription"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AwardTeam",
      "typeName": "AwardTeam"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.ScoreDetail",
      "typeName": "ScoreDetail"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.advancement.CommonAdvancementRank",
      "typeName": "CommonAdvancementRank"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TeamData",
      "typeName": "TeamData"
    },
    {
      "javaClass": "java.lang.Cloneable",
      "typeName": "Cloneable"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams",
      "typeName": "DisplayCommandParams"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayAdvancementConfig",
      "typeName": "DisplayAdvancementConfig"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayAward",
      "typeName": "DisplayAward"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.SelectionState",
      "typeName": "SelectionState"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitResult",
      "typeName": "PitResult"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.inspection.FormType",
      "typeName": "FormType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.inspection.InspectionUpdate$InspectionUpdateStatus",
      "typeName": "InspectionUpdateStatus"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.inspection.InspectionUpdate$InspectionUpdateTeam",
      "typeName": "InspectionUpdateTeam"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.ScriptCustomization",
      "typeName": "ScriptCustomization"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.ranking.BaseRank",
      "typeName": "BaseRank"
    },
    {
      "javaClass": "java.lang.Comparable",
      "typeName": "Comparable"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.MatchAlliance",
      "typeName": "MatchAlliance"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.MatchInfo",
      "typeName": "MatchInfo"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.MatchTeam",
      "typeName": "MatchTeam"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.MatchResultsTeam",
      "typeName": "MatchResultsTeam"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayAwardAssignment",
      "typeName": "DisplayAwardAssignment"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitMessage",
      "typeName": "PitMessage"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.GenericBracket",
      "typeName": "GenericBracket"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.BasicTeam",
      "typeName": "BasicTeam"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TeamSelectionState",
      "typeName": "TeamSelectionState"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.GenericBracket$BracketLayer",
      "typeName": "BracketLayer"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.GenericSeries",
      "typeName": "GenericSeries"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.GenericSeries$SeriesAlliance",
      "typeName": "SeriesAlliance"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.AllianceColor",
      "typeName": "AllianceColor"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.EventTypeKind",
      "typeName": "EventTypeKind"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.SelectionMethod",
      "typeName": "SelectionMethod"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.SelectionOp",
      "typeName": "SelectionOp"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$HighScoreLevel",
      "typeName": "HighScoreLevel"
    },
    {
      "javaClass": "org.firstinspires.ftc.model.HrMeetingNoteType",
      "typeName": "HrMeetingNoteType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.DoubleEliminationSeriesDescription$BracketHalf",
      "typeName": "BracketHalf"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.PlayoffType",
      "typeName": "PlayoffType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.event.playoff.SeriesAllianceState",
      "typeName": "SeriesAllianceState"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AwardId",
      "typeName": "AwardId"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.centerstage.EndGameLocation",
      "typeName": "EndGameLocation"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AdvancementStatus",
      "typeName": "AdvancementStatus"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.CompetingType",
      "typeName": "CompetingType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.AdvancementEligibility",
      "typeName": "AdvancementEligibility"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.decode.DecodeTeleopBaseLocation",
      "typeName": "DecodeTeleopBaseLocation"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.intoTheDeep.ItdAutoLocation",
      "typeName": "ItdAutoLocation"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.intoTheDeep.ItdTeleopLocation",
      "typeName": "ItdTeleopLocation"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.powerplay.FieldSide",
      "typeName": "FieldSide"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.powerplay.AutoNavigation",
      "typeName": "AutoNavigation"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.SponsorLevel",
      "typeName": "SponsorLevel"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TimeoutType",
      "typeName": "TimeoutType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandType",
      "typeName": "DisplayCommandType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.TournamentLevel",
      "typeName": "TournamentLevel"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.DisplayCommandParams$ShowBracket$BracketStyle",
      "typeName": "BracketStyle"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.PitMessageType",
      "typeName": "PitMessageType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.decode.ArtifactType",
      "typeName": "ArtifactType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.powerplay.JunctionElement",
      "typeName": "JunctionElement"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.inspection.StatusType",
      "typeName": "StatusType"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.inspection.Status",
      "typeName": "Status"
    },
    {
      "javaClass": "org.firstinspires.ftc.common.model.display.MatchResultsTeam$RankMove",
      "typeName": "RankMove"
    }
  ]
}